import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Card from '../components/Card';
import FlexBox from '../components/FlexBox';
import LogoImage from '../assets/logonew3.png';
import { Col, Row } from '../components/StyledGridSystem';

const SignOutCard = styled(Card)`
  text-align: center;
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(90deg, #b03434 0%, #184b68 118.29%);
`;

function UnauthorizedPage() {
  return (
    <>
      <Row>
        <Col>
          <SignOutCard>
            <FlexBox
              direction="column"
              justify="center"
              style={{ height: '100%' }}
              space={3}
              alignItems="center">
              <img src={LogoImage} alt="" style={{ marginBottom: '24px' }} />

              <h2>Authorization error.</h2>
              <p>
                Please try again, or contact
                <a
                  style={{ padding: '0 5px 0 5px' }}
                  href="mailto:help@cmkl.ac.th">
                  help@cmkl.ac.th
                </a>
                for assistance.
              </p>
              <p>
                Need to get back in? <Link to="/signin">Sign in again</Link>.
              </p>
            </FlexBox>
          </SignOutCard>
        </Col>
      </Row>
    </>
  );
}

export default UnauthorizedPage;
